// =============================================================================
// App
// =============================================================================

// Import
// =============================================================================
import './lib/responsiveslides';
import './lib/lity.min';

import './partials/header';

import './components/scroll-top';
import './components/slider';
import './components/headline-illustrations';
import './components/side-pager';
import './components/personnel-grid';
import './components/post-grid';

import './elements/input';

// Constants
// =============================================================================

const $body = $('body');
const $window = $(window);
const $document = $(document);

// Document Ready
// =============================================================================

// Window Ready
// =============================================================================

$window.on('load', () => {
    // ...
});
